import { CodeNameModel, FileList } from 'components/common/types';
import { RouteFrameCode } from 'components/common/types/Deal.types';

const extractIncludeExcludeData = (listFiles: FileList[]): CodeNameModel[] => {
  return listFiles.flatMap((uploadedFile) => {
    const categoryChips = [];
    let included = 0;
    let excluded = 0;

    if (uploadedFile.include !== undefined) {
      const fileContentsLength = uploadedFile.fileContents?.length ?? 0;

      included = uploadedFile.include ? fileContentsLength : 0;
      excluded = uploadedFile.include ? 0 : fileContentsLength;
    } else {
      included = uploadedFile.fileContents?.filter((frame) => frame.include).length || 0;
      excluded = uploadedFile.fileContents?.filter((frame) => !frame.include).length || 0;
    }

    if (included > 0) {
      categoryChips.push({
        category: uploadedFile.name,
        include: true,
        code: '',
        name: `${included}`,
      });
    }

    if (excluded > 0) {
      categoryChips.push({
        category: uploadedFile.name,
        include: false,
        code: '',
        name: `${excluded}`,
      });
    }

    return categoryChips;
  });
};

export const generateRouteFramesSelectedDisplay = (
  routeFrameCodes: RouteFrameCode[],
  mapRouteFrameCodes: RouteFrameCode[],
  listFiles: FileList[],
  categoryName?: string,
): CodeNameModel[] => {
  const listOfFiles = listFiles.length >= 1 ? extractIncludeExcludeData(listFiles) : [];

  const selected: CodeNameModel[] = [];
  const includedFrames = routeFrameCodes.filter((frame) => frame.include).length;
  const excludedFrames = routeFrameCodes.filter((frame) => !frame.include).length;

  if (routeFrameCodes.length >= 1) {
    if (includedFrames > 0) {
      selected.push({
        category: categoryName ?? 'Frames',
        code: '',
        name: `${includedFrames}`,
        include: true,
      });
    }

    if (excludedFrames > 0) {
      selected.push({
        category: categoryName ?? 'Frames',
        code: '',
        name: `${excludedFrames}`,
        include: false,
      });
    }
  }

  const mapIncludedFrames = mapRouteFrameCodes.filter((frame) => frame.include).length;

  if (mapRouteFrameCodes.length >= 1 && mapIncludedFrames > 0) {
    selected.push({
      category: 'Map Frames',
      code: '',
      name: `${mapIncludedFrames}`,
      include: true,
    });
  }

  return [...listOfFiles, ...selected];
};
